export default __webpack_public_path__ + "static/media/jpeg.08a98129.svg";